const Colors = {
	primaryColor: '#62BE12',
	secondaryColor: '#767C8C',
	lightGreen: '#A8FD5F',
	buttonColor: '#58AB10',
	grayBackground: '#F7F7F7',
	ratingStar: '#FFB600',
	secondaryText: '#D9D9D9',
}

export default Colors